import React, { Fragment, useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { LocaleContext, TagInput } from 'shared';
import { atLeastOneRequired, combineValidators, isAllUnique, isAllValidUrl } from 'utils/formValidators';

import { ApplicationFormLabel } from '../../ApplicationForm.styles';

export const RedirectUrls = () => {
  const localeContext = useContext(LocaleContext);

  return (
    <Field
      name="redirectUris"
      validate={combineValidators(
        atLeastOneRequired(localeContext.formatMessage({ id: 'FORM.AT-LEAST-ONE-REQUIRED' })),
        isAllValidUrl(localeContext.formatMessage({ id: 'FORM.AT-LEAST-ONE-URL-INCORRECT' }), 'label'),
        isAllUnique(localeContext.formatMessage({ id: 'FORM.ALL-VALUES-SHOULD-BE-UNIQUE' })),
      )}
    >
      {({ input, meta }: { meta: FieldRenderProps<HTMLSelectElement>['meta']; input: any }) => (
        <Fragment>
          <ApplicationFormLabel style={{ marginBottom: '1rem', marginTop: '2rem' }}>
            {localeContext.formatMessage({ id: 'APPLICATION.FORM.REDIRECT-URLS' })}
          </ApplicationFormLabel>
          <TagInput
            input={input}
            meta={meta}
            tagKeyActivators={[',', 'Enter']}
            className="application-form__redirect-urls"
            addOnBlur={true}
            placeholder={localeContext.formatMessage({ id: 'APPLICATION.FORM.TYPE-REDIRECT-URLS' })}
          />
        </Fragment>
      )}
    </Field>
  );
};
